import React, { useState, useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { TABLE_DEFAULT_LIMIT, DEBOUNCE_DELAY } from '../../util/constant';
import { Table } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import useDebounce from '../useDebounce';
import Breadcrumb from '../../components/Breadcrumb';
import { get } from '../../services/apiController';
import { dateFormat } from '../../util/helper';
import AdsAddEditModal from './components/AdsAddEditModal';
import { EditIcon, ViewIcon, DeleteIcon } from '../icons';
import DeleteModal from '../../components/common/DeleteModal';
import { Link } from 'react-router-dom';
import AdsDetail from './components/AdsDetailModal';

function AdsList() {
  const [filters, setFilters] = useState({ query: '' });
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [adsList, setAdsList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [adId, setAdId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);

  const FetchAds = () => {
    get(`/ks-ads/?search=${filters.query}&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`)
      .then((res) => {
        setTotalRecords(res?.data?.count);
        setAdsList(res?.data?.rows);
      })
      .catch((err) => toast.error(err?.response?.data?.data?.message || err?.response?.data?.message || err?.message));
  };

  const handleEdit = (e, adId) => {
    setAdId(adId);
    setShowModal(true);
  };

  const handleView = (e, adId) => {
    setAdId(adId);
    setViewModal(true);
  };

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        FetchAds();
      }
    },
    [filters],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    FetchAds();
  }, [currentPage]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb navigation={[{ link: '#', title: 'Advertisement List' }]} />
      <div className="card top-card">
        <div className="card-body">
          <div className="row">
            <div className="form-group col-md-2 col-lg-3">
              <input
                type="search"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Search for title"
                value={filters.query}
                onChange={(e) => setFilters({ ...filters, query: e.target.value })}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Ads | {totalRecords ?? 0}
          </h4>
          <button onClick={() => setShowModal(true)} type="button" className="btn app-btn-default dark-color">
            Create
          </button>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered className="bill-detail-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Title</th>
                    <th>File Type</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {adsList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td >{item?.title}</td>
                        <td>{item?.fileType}</td>
                        <td>{item?.status}</td>
                        <td className="actions">
                          <span onClick={(e) => handleView(e, item?.id)} className="view-icon m-0">
                            <ViewIcon style={{ color: 'purple' }} />
                          </span>
                          <span onClick={(e) => handleEdit(e, item?.id)} className="edit-icon">
                            <EditIcon style={{ color: 'teal' }} />
                          </span>
                          <Link
                            onClick={(e) => {
                              setDeleteModal(true);
                              setAdId(item.id);
                            }}
                            className="delete"
                          >
                            <DeleteIcon />
                          </Link>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <AdsAddEditModal
          open={showModal}
          onClose={() => {
            setShowModal(false);
            setAdId(null);
          }}
          adId={adId}
          callback={FetchAds}
        />
      )}
      {viewModal && (
        <AdsDetail view={viewModal}
          onClose={() => {
            setViewModal(false);
            setAdId(null);
          }}
          adId={adId}
        />
      )}
      {deleteModal && (
        <DeleteModal
          title="Delete Advertisement"
          description="Are you sure? Action cannot be undone."
          open={deleteModal}
          onClose={() => {
            setDeleteModal(false);
            setAdId(null);
          }}
          url={`/ks-ads/${adId}`}
          callback={FetchAds}
        />
      )}
    </React.Fragment>
  );
}

export default AdsList;
